<template>
<span>
  <v-select :items="values" multiple item-text="value" item-value="key" :menu-props="{ maxHeight: '400' }" :label="label" v-model="model"></v-select>
  {{ description }}
</span>
</template>

<script>
import {
  input
} from '@/mixins/input'

export default {
  created() {},
  computed: {
    values() {
      return this.field.values
    }
  },
  mixins: [input]
}
</script>

<style>
</style>
